// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"TE6j-ioDhb1Sm9Vh2YUyg"};